import { REMOVE_UPLOADED_MEDIA_FILE_RECORD } from 'actions';

export function removeUploadedMediaFileRecord(mediaFileRecordIndex: number) {
  return {
    mediaFileRecordIndex,
    type: REMOVE_UPLOADED_MEDIA_FILE_RECORD,
  };
}
